import { PullToRefresh } from "../components/PullToRefresh";
import { useMarketplaceController } from "./marketplace/useMarketplaceController";
import { MarketplaceView } from "./marketplace/MarketplaceView";
export { SURFACE_META } from "./marketplace/model";

export default function Marketplace(props: { surface?: string } = {}) {
  const state = useMarketplaceController(props);
  return <PullToRefresh identity={`${state.refreshIdentity}:${state.savedMutationPending}`}
    disabled={state.loading || state.showFilters || state.savedMutationPending} onRefresh={state.refreshDiscovery}>
    <MarketplaceView {...state} />
  </PullToRefresh>;
}
